document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.blog-tab');
    const contents = document.querySelectorAll('.blog-content');
  
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        // active を全解除
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('show'));
  
        // クリックしたタブを有効化
        tab.classList.add('active');
        if (contents[index]) {
          contents[index].classList.add('show');
        }
      });
    });
  });